import { RoundedBox } from '@react-three/drei'
import { MeshProps } from '@react-three/fiber'
import { frontBar } from '../helper/verandaDimensions'
import { useMeasures } from '../../../../../hooks/state/useMeasures'
import { useRoof } from '../../../../../hooks/state/useRoof'
import { Helper } from '../../../../../classes/helper'
import { detachedBar } from '../helper/verandaDimensions'
import { CachedMeshPhysicalMaterial } from '../../../../material/cachedMeshPhysicalMaterial'

interface Props extends MeshProps {
  logBarHeight: number
  rotate?: number
}

export const LogsBarSquare = ({
  position,
  logBarHeight,
  rotate = 0,
}: Props): JSX.Element => {
  const { verandaTyp } = useMeasures()
  const { color } = useRoof()

  return (
    <mesh
      position={position}
      castShadow={true}
      rotation={[Helper.convertAngleToRadiant(0), rotate, 0]}
    >
      <RoundedBox
        args={[verandaTyp.log.width, logBarHeight, verandaTyp.log.depth]}
        radius={0.0005}
        smoothness={0.5}
        castShadow={true}
        matrixWorldAutoUpdate={undefined}
        getObjectsByProperty={undefined}
        getVertexPosition={undefined}
      >
        <CachedMeshPhysicalMaterial color={color} />
      </RoundedBox>
    </mesh>
  )
}
